import React from "react";

/*
 * Placeholder for the drawer's thread while a chat is fetched -- switching from
 * recent chats or starting a new one used to leave the old conversation on
 * screen until the new one arrived, which read as a frozen panel.
 *
 * Shaped like a real exchange (a short question on the right, a longer answer
 * on the left) so the panel keeps its rhythm instead of flashing a spinner.
 */
const ChatSkeleton = () => (
  <div className="cdSkeleton" aria-busy="true" aria-label="Loading chat">
    <div className="cdSkeleton__row cdSkeleton__row--me">
      <span className="cdSkeleton__bubble" style={{ width: "48%" }} />
    </div>
    <div className="cdSkeleton__row">
      <span className="cdSkeleton__line" style={{ width: "82%" }} />
      <span className="cdSkeleton__line" style={{ width: "94%" }} />
      <span className="cdSkeleton__line" style={{ width: "64%" }} />
    </div>
    <div className="cdSkeleton__row cdSkeleton__row--me">
      <span className="cdSkeleton__bubble" style={{ width: "34%" }} />
    </div>
    <div className="cdSkeleton__row">
      <span className="cdSkeleton__line" style={{ width: "70%" }} />
      <span className="cdSkeleton__line" style={{ width: "88%" }} />
    </div>
  </div>
);

export default ChatSkeleton;
